import { c as _c } from "react/compiler-runtime";
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import ShopByHeaderSection from 'components/consumer/ShopByHeaderSection';
import ColorsFilter from 'components/essentials/ColorsFilter';
import useUpholsteryFilteredEvent from 'data-hooks/useEvents/useUpholsteryFilteredEvent';
const ColorFilters = t0 => {
  const $ = _c(14);
  const {
    fabricColors,
    toggleSelectedColor,
    selectedColors,
    selectedFabric
  } = t0;
  let t1;
  bb0: {
    if (selectedFabric) {
      let t2;
      if ($[0] !== selectedFabric.option.type) {
        t2 = {
          name: selectedFabric.option.type
        };
        $[0] = selectedFabric.option.type;
        $[1] = t2;
      } else {
        t2 = $[1];
      }
      let t3;
      if ($[2] !== selectedFabric.footerTitle.name || $[3] !== selectedFabric.option.id || $[4] !== t2) {
        t3 = {
          id: selectedFabric.option.id,
          name: selectedFabric.footerTitle.name,
          type: t2
        };
        $[2] = selectedFabric.footerTitle.name;
        $[3] = selectedFabric.option.id;
        $[4] = t2;
        $[5] = t3;
      } else {
        t3 = $[5];
      }
      t1 = t3;
      break bb0;
    }
    t1 = null;
  }
  const basicDetails = t1;
  const {
    upholsteryFilteredEvent
  } = useUpholsteryFilteredEvent(basicDetails, null, null, "Swatches");
  let t2;
  if ($[6] !== selectedColors || $[7] !== toggleSelectedColor || $[8] !== upholsteryFilteredEvent) {
    t2 = color => {
      toggleSelectedColor(color);
      if (!selectedColors[color]) {
        upholsteryFilteredEvent(null, color.toLowerCase(), null);
      }
    };
    $[6] = selectedColors;
    $[7] = toggleSelectedColor;
    $[8] = upholsteryFilteredEvent;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  let t3;
  if ($[10] !== fabricColors || $[11] !== selectedColors || $[12] !== t2) {
    t3 = <ShopByHeaderSection label="Color"><ColorsFilter colors={fabricColors} selectedColors={selectedColors} onSelectColor={t2} showAsTwoRows={true} variant="ShopByHeaderSection" /></ShopByHeaderSection>;
    $[10] = fabricColors;
    $[11] = selectedColors;
    $[12] = t2;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  return t3;
};
ColorFilters.propTypes = {
  fabricColors: PropTypes.node,
  toggleSelectedColor: PropTypes.func,
  selectedColors: PropTypes.node,
  selectedFabric: PropTypes.object
};
export default ColorFilters;